import { Component, OnInit, inject } from '@angular/core';
import { VersionService } from './core/services/version.service';
import { ExternalScriptsService } from './core/services/external-scripts.service';
import { AuthService } from './core/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private versionService = inject(VersionService);
  private externalScriptsService = inject(ExternalScriptsService);
  private authService = inject(AuthService);

  ngOnInit(): void {
    // Reset the dismissed state when the app initializes
    this.versionService.resetDismissedState();

    // Check for version mismatch
    this.versionService.checkVersion().subscribe();

    // Start listening for app updates
    this.versionService.initUpdateListener();

    this.authService.user$.subscribe(() => {
      if (this.authService.isAuthenticated()) {
        this.externalScriptsService.removeScript('widget-no-login');
        this.externalScriptsService.loadLoggedWidget();
      }
      else {
        this.externalScriptsService.removeScript('widget-login');
        this.externalScriptsService.loadNotLoggedWidget();
      }
    });
  }
  
}
